import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import * as actions from "../../actions";
import { Image as CloudinaryImage, Transformation } from 'cloudinary-react';
import Image from '../Image/Image.jsx';
import { UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';

class VoterInfoModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            timeout: ""
        }
    }
    componentDidMount() { }

    render() {
        let { data } = this.props;

        return (
            <div className="modal" id="ticketmodal" tabIndex="-1" role="dialog" aria-hidden="true" style={this.props.open ? { display: 'block' } : {}} onClick={this.props.modalClose}>
                <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                    <div className="modal-content animated bounceIn" onClick={e => e.stopPropagation()}>
                        <div className="ticket-modal">
                            <React.Fragment>
                                <div className="reportcontent">
                                    <p className="mb-0 cotmed">User Profile</p>
                                </div>
                                <div className="modalmaincontent voterinfocontent">
                                    <div className="coverphoto">
                                        {
                                            data.coverPic == null || data.coverPic == "null" || data.coverPic == undefined || data.coverPic == ""
                                                ? <Image src={require('../../img/blacklayer.png')} />
                                                : <CloudinaryImage cloudName="contestee" publicId={data.coverPic} crop="scale" width="250" className="cover-pic" />
                                        }
                                    </div>
                                    <div className="circle mb-3">
                                        <CloudinaryImage cloudName="contestee" publicId={data.profilePic} crop="scale" width="250" className="rounded-circle profile-pic" />
                                    </div>
                                    <h6 className="text-center cotmed mb-2">{`${data.firstName} ${data.lastName}`}</h6>
                                    {data.locationInfo != undefined ? <p className="text-center f-14 mb-2">{`${data.locationInfo.city}, ${data.locationInfo.countryName}`}</p> : null}
                                    <p className="text-center f-14 mb-0">Regular User</p>
                                </div>
                            </React.Fragment>
                            <div className="modalfooter pointer" onClick={this.props.modalClose}>
                                <button className="col-secondary">OK</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ voterInfoModal, user }) => {
    const { open, data } = voterInfoModal;
    return { open, data };
};

const mapDispatchToProps = dispatch => ({
    modalClose: () => dispatch(actions.voterInfoModalClose()),
    giveVote: payload => dispatch(actions.giveVote(payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VoterInfoModal);